import * as types from './mutation-types'
import _ from 'lodash'

/**
 * Category Actions
 */
export const discussionGetCategories = ({ commit, state }, options) => {
  options = _.extend({
    params: {},
    force: false,
  }, options)

  if (state.discussion.categories.data.length && !options.force) {
    return Promise.resolve(state.discussion.categories)
  }
  return Vue2.prototype.$api.active().get('discussions/categories?include=membershipGroups', {
    params: options.params,
  }).then((response) => {
    commit(types.DISCUSSION_SET_CATEGORIES, response.data)
  })
}

export const discussionCreateCategory = ({ commit, state }, params) => {
  return Vue2.prototype.$api.active().post('discussions/categories',
    params
  )
    .then((response) => {
      commit(types.DISCUSSION_SET_CATEGORY, response.data)
      commit(types.DISCUSSION_ADD_CATEGORY, response.data)
      commit('baseAddNotification', {
        type: 'success',
        title: 'Success',
        text: 'Category created!',
      })

      return response
    })
}

export const discussionGetCategory = ({ commit, state }, options) => {
  options = _.extend({
    categoryUuid: false,
    params: {},
    force: false,
  }, options)

  if (state.discussion.category && !options.force) {
    if (state.discussion.category.uuid === options.categoryUuid) {
      return Promise.resolve(state.discussion.category)
    }
  }
  return Vue2.prototype.$api.active().get('discussions/categories/' + options.categoryUuid, {
    params: options.params,
  }).then((response) => {
    commit(types.DISCUSSION_SET_CATEGORY, response.data)
  })
}

export const discussionSetCategoryMembershipGroups = ({ commit, state }, options) => {
  options = _.extend({
    categoryUuid: false,
    params: {},
  }, options)

  return Vue2.prototype.$api.active().post('discussions/categories/' + options.categoryUuid + '/groups',
    options.params
  ).then((response) => {

  })
}

export const discussionUpdateCategory = ({ commit, state }, options) => {
  options = _.extend({
    categoryUuid: false,
    params: {},
  }, options)

  return Vue2.prototype.$api.active().put('discussions/categories/' + options.categoryUuid + '?include=membershipGroups',
    options.params
  ).then((response) => {
    commit(types.DISCUSSION_SET_CATEGORY, response.data)
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Category updated!',
    })
  })
}

export const discussionRemoveCategory = ({ commit, state }, categoryUuid) => {
  return Vue2.prototype.$api.active().delete('discussions/categories/' + categoryUuid).then((response) => {
    commit(types.DISCUSSION_REMOVE_CATEGORY, categoryUuid)
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Category archived!',
    })
  })
}

export const discussionRestoreCategory = ({ commit, state }, categoryUuid) => {
  return Vue2.prototype.$api.active().put('discussions/categories/' + categoryUuid + '/restore').then((response) => {
    commit(types.DISCUSSION_REMOVE_CATEGORY, categoryUuid)
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Category restored!',
    })
  })
}

/**
 * Post Actions
 */
export const discussionGetPosts = ({ commit, state }, options) => {
  options = _.extend({
    params: {},
    force: false,
  }, options)

  if (state.discussion.posts.data.length && !options.force) {
    return Promise.resolve(state.discussion.posts)
  }

  return Vue2.prototype.$api.active().get('discussions/posts', {
    params: options.params,
  }).then((response) => {
    commit(types.DISCUSSION_SET_POSTS, response.data)
  })
}

export const discussionGetArchivedPosts = ({ commit, state }, options) => {
  options = _.extend({
    params: {
      archived: true,
      include: 'category',
    },
    force: false,
  }, options)

  if (state.discussion.archivedPosts.data.length && !options.force) {
    return Promise.resolve(state.discussion.archivedPosts)
  }

  return Vue2.prototype.$api.active().get('discussions/posts', {
    params: options.params,
  }).then((response) => {
    commit(types.DISCUSSION_SET_ARCHIVED_POSTS, response.data)
  })
}

export const discussionGetPost = ({ commit, state }, options) => {

  options = _.extend({
    postUuid: false,
    params: {},
    force: false,
  }, options)

  if (state.discussion.post && !options.force) {
    if (state.discussion.post.uuid === options.postUuid) {
      return Promise.resolve(state.discussion.post)
    }
  }

  return Vue2.prototype.$api.active().get('discussions/posts/' + options.postUuid, {
    params: options.params,
  }).then((response) => {
    commit(types.DISCUSSION_SET_POST, response.data)
  })
}

/**
 * @param commit
 * @param Form
 * @returns {*}
 */
export const discussionCreatePost = ({ commit }, Form) => {
  Form.startProcessing()

  return Vue2.prototype.$api.active()
    .post(
      `discussions/categories/${Form.category.uuid}/posts?include=category,lastReply`,
      {
        title: Form.title,
        body: Form.body,
      }
    ).then((response) => {

      let categorySlug = response.data.category.attributes.slug
      let postSlug = response.data.attributes.slug


      if (response.data.attributes.status === 'Approved') {
        Form.statusMessage = 'Discussion created!'
        Form.redirect = Vue2.prototype.$urlGenerator.active(
          `discussions/${categorySlug}/${postSlug}?status=${Form.statusMessage}`
        )
      }

      if (response.data.attributes.status === 'Pending') {
        Form.statusMessage = 'Your discussion has been submitted for admin approval!'
        Form.redirect = Vue2.prototype.$urlGenerator.active(
          `discussions?status=${Form.statusMessage}`
        )
      }

      return response

    }).catch((errors) => {

      if (errors.response.status === 500) {
        commit('baseAddNotification', {
          type: 'danger',
          text: 'A server error occurred.',
          timeout: false,
        })
      }

      Form.setErrors(errors.response.data)

      throw new Error(errors)
    })
}

/**
 * @param commit
 * @param state
 * @param Form
 * @returns {Promise<T | never>}
 */
export const discussionUpdatePost = ({ commit, state }, Form) => {
  Form.startProcessing()

  return Vue2.prototype.$api.active()
    .put(`discussions/posts/${Form.uuid}?include=category`,
      {
        title: Form.title,
        body: Form.body,
      }
    ).then((response) => {

      if(Form.documentsToRemove.length) {
        Form.documentsToRemove.forEach(function (documentUuid) {
          Vue2.prototype.$api.active().delete(`documents/${documentUuid}`)
        })
      }

      Form.statusMessage = 'Discussion has been updated!'

      return response
    }).catch((errors) => {
      Form.setErrors(errors.response.data)

      throw new Error(errors)
    })
}

export const discussionApprovePost = ({ commit, state }, post) => {
  if (!_.has(post, '_links.api.actions.approve')) {
    return Promise.reject('You\'re not allowed to approve posts.')
  }

  let request = Vue2.prototype.$api.active().post(post._links.api.actions.approve)

  request.then((response) => {
    if (state.discussion.post.uuid === post.uuid) {
      commit(types.DISCUSSION_SET_POST, response.data)
    }
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Discussion was approved!',
    })
  })

  return request
}

export const discussionRejectPost = ({ commit, state }, post) => {
  if (!_.has(post, '_links.api.actions.decline')) {
    return Promise.reject('You\'re not allowed to reject posts.')
  }

  let request = Vue2.prototype.$api.active().post(post._links.api.actions.decline)

  request.then((response) => {
    if (state.discussion.post.uuid === post.uuid) {
      commit(types.DISCUSSION_SET_POST, response.data)
    }
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Discussion was rejected!',
    })
  })

  return request
}

export const discussionRemovePost = ({ commit, state }, options) => {
  options = _.extend({
    postUuid: false,
    redirect: false,
  }, options)

  return Vue2.prototype.$api.active().delete('discussions/posts/' + options.postUuid).then((response) => {

    commit(types.DISCUSSION_REMOVE_POST, options.postUuid)

    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Discussion removed!',
    })

    if (options.redirect) {
      window.location.href = options.redirect
    }
  })
}

export const discussionRestorePost = ({ commit, state }, postUuid) => {
  return Vue2.prototype.$api.active().put('discussions/posts/' + postUuid + '/restore').then((response) => {
    commit(types.DISCUSSION_REMOVE_POST, postUuid)
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Discussion restored!',
    })
  })
}

/**
 * Reply Actions
 */

export const discussionGetReplies = ({ commit, state }, options) => {
  options = _.extend({
    postUuid: false,
    params: {},
    force: false,
  }, options)

  if (state.discussion.replies.data.length && !options.force) {
    return Promise.resolve(state.discussion.replies)
  }
  return Vue2.prototype.$api.active().get('discussions/posts/' + options.postUuid + '/replies', {
    params: options.params,
  }).then((response) => {
    commit(types.DISCUSSION_SET_REPLIES, response.data)

    return response
  })
}

export const discussionCreateReply = ({ commit, state }, options) => {
  options = _.extend({
    postUuid: false,
    params: {},
  }, options)

  return Vue2.prototype.$api.active().post('discussions/posts/' + options.postUuid + '/replies',
    options.params
  ).then((response) => {
    if (response.data.attributes.status === 'Approved') {
      commit(types.DISCUSSION_SET_REPLY, response.data)
      commit(types.DISCUSSION_ADD_REPLY, response.data)
      commit('baseAddNotification', {
        type: 'success',
        text: 'Reply posted!',
      })
    }
    if (response.data.attributes.status === 'Pending') {
      commit('baseAddNotification', {
        type: 'success',
        text: 'Your reply has been submitted for admin approval!',
      })
    }
  })
}

export const discussionUpdateReply = ({ commit, state }, { replyUuid, params }) => {
  let request = Vue2.prototype.$api.active().put('discussions/replies/' + replyUuid, params)
  request.then((response) => {
    commit(types.DISCUSSION_SET_REPLY, response.data)
    commit('baseAddNotification', {
      type: 'success',
      text: 'Reply updated!',
    })
  })
  return request
}

export const discussionRemoveReply = ({ commit, state }, replyUuid) => {
  return Vue2.prototype.$api.active().delete('discussions/replies/' + replyUuid).then((response) => {
    commit(types.DISCUSSION_REMOVE_REPLY, replyUuid)
    commit('baseAddNotification', {
      type: 'success',
      text: 'Reply removed!',
    })
  })
}

export const discussionApproveReply = ({ commit, state }, reply) => {
  if (!_.has(reply, '_links.api.actions.approve')) {
    return Promise.reject('You\'re not allowed to approve replies.')
  }

  let request = Vue2.prototype.$api.active().post(reply._links.api.actions.approve)

  request.then((response) => {
    if (state.discussion.reply.uuid === reply.uuid) {
      commit(types.DISCUSSION_SET_REPLY, response.data)
    }
    commit('baseAddNotification', {
      type: 'success',
      text: 'Discussion reply was approved!',
    })
  })

  return request
}

export const discussionRejectReply = ({ commit, state }, reply) => {
  if (!_.has(reply, '_links.api.actions.decline')) {
    return Promise.reject('You\'re not allowed to reject replies.')
  }

  let request = Vue2.prototype.$api.active().post(reply._links.api.actions.decline)

  request.then((response) => {
    if (state.discussion.reply.uuid === reply.uuid) {
      commit(types.DISCUSSION_SET_REPLY, response.data)
    }
    commit('baseAddNotification', {
      type: 'success',
      text: 'Discussion reply was rejected!',
    })
  })

  return request
}